import { useTranslations } from '@vocab/react';
import { ButtonLink, IconStatistics } from 'braid-design-system';
import { useRef, useEffect } from 'react';

import { SEARCH_PAGE_TRACKING_EVENTS } from 'src/App/services/tracking/trackingConfig';
import { useTracking } from 'src/App/services/tracking/useTracking';

import translations from './.vocab';
import { NudgeBanner } from './NudgeBanner';

const VISIBILITY_SETTING_URL =
  '/profile/me/profile-visibility-v2?mode=edit&tracking=ILC-profileVisibility-profileSearchResults';

export const NudgeProfilePublicBanner = () => {
  const { t } = useTranslations(translations);
  const trackingCallbacks = useTracking(SEARCH_PAGE_TRACKING_EVENTS);
  const hasTrackedDisplayRef = useRef(false);

  useEffect(() => {
    if (!hasTrackedDisplayRef.current) {
      trackingCallbacks.makeProfilePublicBanner.trackComponentDisplayedEvent({
        component: {
          name: 'cta-make-your-profile-public',
          type: 'dialog',
        },
      });
      hasTrackedDisplayRef.current = true;
    }
  }, [trackingCallbacks]);
  return (
    <NudgeBanner
      title={
        <>
          {t('NOT_MANY_RESULT_YET')} {t('BUT_WE_ARE_GROWING_FAST')}
        </>
      }
      description={t(
        'WE_HAVE_MILLIONS_OF_PROFILES_BUT_APPEAR_ONLY_WHEN_MADE_PROFILES_PUBLIC',
      )}
      actionButton={
        <ButtonLink
          onClick={() =>
            trackingCallbacks.makeProfilePublicBanner.trackComponentPressedEvent(
              {
                component: {
                  name: 'make-your-profile-public',
                  type: 'button',
                },
              },
            )
          }
          href={VISIBILITY_SETTING_URL}
          icon={<IconStatistics />}
          tone="brandAccent"
        >
          {t('MAKE_YOUR_PROFILE_PUBLIC')}
        </ButtonLink>
      }
    />
  );
};
